export interface FilterParams {
  sort?: 'asc' | 'desc';
  rangeMin?: number;
  rangeMax?: number;
  variety?: string[];
  type?: string[];
  q?: string;
  year?: string;
}

export const defaultFilterParams: any = {
  sort: 'asc',
  rangeMin: 0,
  rangeMax: 5000,
};

export function removeDefaultFilterParams(filterParams: FilterParams) {
  return Object.entries(filterParams)
    .filter(([key, value]) => !!value)
    .reduce((acc, [key, value]: any) => {
      if (defaultFilterParams[key] && defaultFilterParams[key] === value) {
        return acc;
      } else if (Array.isArray(value) && value.length) {
        acc[key] = value;
      } else if (String(value || '').trim() !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);
}

export function getLotFilterParams(
  params: URLSearchParams,
  year?: string
): FilterParams {
  return {
    sort: params.get('sort') === 'desc' ? 'desc' : 'asc',
    rangeMin: Number(params.get('rangeMin') ?? defaultFilterParams.rangeMin),
    rangeMax: Number(params.get('rangeMax') ?? defaultFilterParams.rangeMax),
    variety: params.getAll('variety') || [],
    type: params.getAll('type') || [],
    q: params.get('q') || '',
    year: year || '',
  };
}

export function setLotFilterParams(
  prevParams: FilterParams,
  nextParams: FilterParams,
  appendItem?: boolean
) {
  const updatedParams = Object.entries(nextParams).reduce(
    (acc, [key, value]) => {
      if (Array.isArray(acc[key])) {
        if (appendItem === false) {
          acc[key] = []
            .concat(acc[key])
            .filter((item: string) => !value.includes(item));
        } else {
          acc[key] = [].concat(acc[key]).concat(value);
        }
      } else {
        acc[key] = value;
      }
      return acc;
    },
    prevParams as any
  );

  return removeDefaultFilterParams(updatedParams);
}
